export default (number) => {
    return new Promise((resolve, reject) => {
        let results = [...Array(number)];

        results = results.map((item, index) => index + 1);

        if (typeof number === 'number') resolve(results)
        else reject(new Error('The pages list must be a number'))
    })
}